
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#171C26","fill-rule":"evenodd","d":"M3 0c.367 0 .667.3.667.667 0 .833.133 1.633.38 2.38a.669.669 0 01-.11.615l-.057.065-1.75 1.73a10.095 10.095 0 004.16 4.269l.233.123 1.75-1.729a.683.683 0 01.68-.16 7.6 7.6 0 002.38.38.67.67 0 01.662.59l.005.077v2.326c0 .367-.3.667-.667.667C5.073 12 0 6.927 0 .667 0 .327.259.043.59.005L.666 0H3zm5.781 8.742l-1.618 1.6.024.011c1.212.52 2.541.818 3.936.845h.077v-2.06l-.167-.003a8.415 8.415 0 01-2.082-.34l-.17-.053zM2.87.8H.8l.001.076c.026 1.326.297 2.592.769 3.754l.074.18L3.26 3.213l-.061-.197A8.369 8.369 0 012.872.968L2.869.8z","clip-rule":"evenodd"}})])
          )
        }
      }
    